<template>
  <component
    :is="resolvedComponent"
    :data="slide.visual || {}"
    :config="config"
    :progress="progress"
  />
</template>

<script>
import TitleCard from './SlideTemplates/TitleCard.vue'
import TextCenter from './SlideTemplates/TextCenter.vue'
import BulletList from './SlideTemplates/BulletList.vue'
import Outro from './SlideTemplates/Outro.vue'
import HtmlFrame from './SlideTemplates/HtmlFrame.vue'

const TEMPLATE_MAP = {
  'title-card': TitleCard,
  'text-center': TextCenter,
  'bullet-list': BulletList,
  outro: Outro,
  html: HtmlFrame
}

export default {
  name: 'SlideRenderer',
  components: { TitleCard, TextCenter, BulletList, Outro, HtmlFrame },
  props: {
    slide: { type: Object, required: true },
    config: { type: Object, default: () => ({}) },
    progress: { type: Number, default: 1 }
  },
  computed: {
    resolvedComponent() {
      const template = this.slide?.visual?.template || this.slide?.type
      return TEMPLATE_MAP[template] || TextCenter
    }
  }
}
</script>
